import React from "react";
import NumberBox from 'devextreme-react/number-box';

function LVNumberBox({ TextoLabel, width, value, onValueChange }) {

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '5px' }}>
      {TextoLabel}
      <NumberBox
        width={width}
        showClearButton={true}
        value={value}
        onValueChange={onValueChange}
      />
      <br />
    </div>
  );
}

export default LVNumberBox

